import React, { useEffect, useState } from 'react'

import { Input, Modal } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import '../../../../assets/shared/modal-inner-container.scss'

const { TextArea } = Input

const InternshipRequestRefusalModal = ({ loading = false, visible = false, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  const [refusalReason, setRefusalReason] = useState('')

  useEffect(() => {
    if (!visible) {
      setRefusalReason('')
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={t('internship_requests_table.actions.refuse_title')}
      onCancel={onCancel}
      onOk={() => onConfirm(refusalReason.trim())}
      okText={t('common.refuse')}
      okType='danger'
      okButtonProps={{ disabled: refusalReason.trim() === '' }}
      cancelText={t('common.cancel')}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <div className='modal-inner-container warning'>
        {t('internship_requests_table.actions.refuse_content')}
      </div>
      <div className='mt-16'>
        <TextArea
          maxLength={500}
          rows={4}
          value={refusalReason}
          placeholder={t('internship_requests_table.actions.refuse_reason_placeholder')}
          onChange={event => setRefusalReason(event.target.value)}
        />
      </div>
    </Modal>
  )
}

export default InternshipRequestRefusalModal
